import React, { useState, useEffect } from 'react';
import { intervalToDuration } from 'date-fns';
import Box from '@mui/material/Box';

function CountdownTimer({ timestamp, setShowBanner }) {
  const [isMounted, setIsMounted] = useState(true);

  const calculateTimeLeft = () => {
    const now = new Date();
    const endTime = new Date(timestamp);
    if (now >= endTime) {
      setShowBanner(false);
      return '0 дн : 00 ч : 00 мин : 00 сек';
    }
    const duration = intervalToDuration({ start: now, end: endTime });
    const formatNumber = (number) => String(number).padStart(2, '0');

    let timeString = `${duration.days} дн : ${formatNumber(
      duration.hours,
    )} ч : ${formatNumber(duration.minutes)} мин`;

    if (duration.days <= 9) {
      timeString += ` : ${formatNumber(duration.seconds)} сек`;
    }
    return timeString;
  };

  const [timeLeft, setTimeLeft] = useState('- дн : -- ч : -- мин : -- сек');

  useEffect(() => {
    const timer = setInterval(() => {
      if (isMounted) {
        setTimeLeft(calculateTimeLeft());
      }
    }, 1000);

    return () => {
      setIsMounted(false);
      clearInterval(timer);
    };
  }, []);
  if (Date.now() > timestamp) {
    return;
  }
  return (
    <Box
      sx={{
        textWrap: 'nowrap',
        color: 'white',
        borderRadius: 1,
        fontSize: 'inherit',
      }}
    >
      {timeLeft}
    </Box>
  );
}

export default CountdownTimer;
